<template>
    <section class="position-relative pb-2 px-4 w-100 text-center bg-trapz">
        <h3 class="font-weight-bold">Trouvez votre terrain</h3>
        <p class="px-3 px-sm-5">Choisissez votre emplacement et sélectionnez une date pour trouver un terrain et réserver votre match.</p>
        <form @submit.prevent="submitSearch" class="d-inline-flex justify-content-between my-3 px-2 mb-5 w-100 shadow-sm border rounded-pill bg-light">
            <div class="px-1 px-lg-2 d-flex align-items-center h-100 w-100">
                <svg class="text-lg" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 256" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path>
                </svg>
                <v-select :options="governorates" name="location" v-model="location" label="option" :reduce="option => option" placeholder="Où?" clearable class="custom-vs bg-transparent w-100 h-100 border-0 ml-1 text-sm">
                </v-select>
            </div>
            <div class="px-1 px-lg-2 d-flex align-items-center h-100 w-100">
                <svg class="text-lg" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 256" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z"></path>
                </svg>
                <input type="text" name="date" class="date bg-transparent w-100 h-100 border-0 pr-2 ml-1 text-sm" role="button" readonly placeholder="Quand?" />
            </div>
            <button type="submit" :disabled="!date || !location" class="d-flex my-2 px-3 align-items-center justify-content-center rounded-pill bg-white border-0 shadow-sm">
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 256" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path></svg>
                <p class="sr-only">Find venues</p>
            </button>
        </form>
        <hr class="w-25 mt-4"/>
    </section>
</template>
<style>
    section.bg-trapz {
        background-image: url('~@/assets/img/trapz.svg');
        background-size: contain;
        background-repeat: no-repeat;
        max-width: 768px;
        margin: -200px auto 0;
        padding-top: 120px;
        padding-bottom: 55px;
        z-index: 1150;
    }

    section form, .sticky-top form {
        height: 50px;
        max-width: 600px;
    }

    section form > div, .sticky-top form > div {
        min-width: 40%;
    }

    .custom-vs .vs__search, .custom-vs .vs__search:focus {
        border: none;
        padding-left: 0;
        margin-left: 0;
        font-size: .875rem;
    }

    .custom-vs .vs__search::placeholder,
    .custom-vs .vs__dropdown-toggle {
        background: transparent;
        border: none;
        width: 100%;
        height: 100%;
    }

    .custom-vs .vs__actions .vs__open-indicator {
        display: none;
    }

    .custom-vs .vs__dropdown-menu {
        top: calc(100% + 1px);
        padding: 0;
        width: max-content !important;
    }

    .custom-vs .vs__selected-options {
        align-items: center;
        overflow: hidden;
        padding-left: 0;
        margin-left: 0;
    }

    .custom-vs .vs__selected {
        white-space: nowrap;
        padding-left: 0;
        margin-left: 0;
        width: fit-content !important;
    }

    .vs--single .vs__selected {
        position: absolute;
    }

    .vs--open .vs__selected {
        width: 100%;
    }

    .custom-vs .vs__clear {
        margin: 0;
    }

    .custom-vs .vs__actions {
        padding-left: .25rem;
        padding-right: .25rem;
    }

    .custom-vs .vs__dropdown-option--highlight {
        background: whitesmoke;
        color: black;
    }

    @media (max-width: 709px) {
        section.bg-trapz {
            margin: -195px auto 0;
            padding-top: 100px;
        }
    }

    @media (max-width: 625px) {
        section.bg-trapz {
            margin: -160px auto 0;
            padding-top: 90px;
        }
    }

    @media (max-width: 520px) {
        section.bg-trapz {
            margin: -110px auto 0;
            padding-top: 70px;
        }
    }
</style>
<script>
import vSelect from "vue-select";
import { api } from '@/store';

import "vue-select/dist/vue-select.css";

export default {
    components: {
        vSelect
    },
    data() {
        return {
            date: null,
            location: null,
            governorates: [],
            attrs: [
                {
                    key: 'today',
                    highlight: true,
                    dates: new Date(),
                },
            ],
        }
    },
    created() {
        const vm = this
        this.getGovernorates()
        $(document).ready(function() {
            $('.date').datepicker({
                dateFormat: 'd/m/yy',
                minDate: 0,
                maxDate: "+1M",
                // dayNamesShort: $.datepicker.regional[ "fr" ].dayNamesShort,
                // dayNames: $.datepicker.regional[ "fr" ].dayNames,
                // monthNamesShort: $.datepicker.regional[ "fr" ].monthNamesShort,
                // monthNames: $.datepicker.regional[ "fr" ].monthNames,
                onSelect: (dateText) => {
                    vm.date = dateText;
                }
            });
        })
    },
    mounted() {
        this.$nextTick(() => {
            $('.custom-vs .vs__search').addClass('text-sm text-muted');
            $('.custom-vs .vs__actions .vs__clear').addClass('mr-0');
        });
    },
    methods: {
        getGovernorates() {
            api.get('/public/governorates')
                .then(response => {
                    const result = response.data
                    this.governorates = result
                })
        },
        formatLabel(option) {
            if (!option || typeof option !== "string") return "";
            const [delegation, state] = option.split(", ");
            return '<b>' + delegation + '</b>, ' + state;
        },
        submitSearch() {
            this.$router.push({
                name: 'search',
                query: {
                    date: this.date,
                    location: this.location
                }
            })
        }
    }
}
</script>